import styled from 'styled-components';

export const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 16px;

  /* border: 1px solid red; */
  /* max-width: 800px; */
`;

export const NavbarForm = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 50px;
  padding: 0 8px;

  .broker {
    input,
    select {
      font: inherit;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      width: 100%;
      color: #333;
      border: none;
      height: 34px;
      outline: none;
      display: block;
      padding: 6px 12px;
      border-radius: 8px;
      transition: all 0.2s ease;
      background-color: #ecf0f1;
      border-bottom: 2px solid transparent;

      :hover {
        border-color: #f26522;
      }
    }
  }

  .stock {
    select {
      font: inherit;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      width: 100%;
      min-width: 140px;
      color: #333;
      border: none;
      height: 34px;
      outline: none;
      display: block;
      padding: 6px 12px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;
      background-color: #ecf0f1;
      border-bottom: 2px solid transparent;

      :hover {
        border-color: #f26522;
      }
    }
  }

  .area-form {
    width: auto;
    display: flex;
    padding: 0;
    justify-content: flex-start;
    gap: 4px;
  }

  .filter {
    width: auto;
    display: flex;
    align-items: center;

    /* height: 50px; */
    font-size: 18px;
    line-height: 20px;
    color: #777;
  }

  .area-btn {
    width: auto;
    display: flex;
    padding: 0;
    align-items: center;
    gap: 8px;

    button {
      width: auto;
      height: 34px;
      white-space: nowrap;
      padding: 5px 15px;
    }

    .btn-only-agendaments {
      /* width: 100%; */
      padding: 0;
      margin: 0;
    }
  }

  input {
    font: inherit;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    width: 100%;
    color: #333;
    border: none;
    height: 34px;
    outline: none;
    display: block;
    padding: 6px 12px;
    border-radius: 8px;
    transition: all 0.2s ease;
    background-color: #ecf0f1;
    border-bottom: 2px solid transparent;

    :hover {
      border-color: #f26522;
    }
  }
`;

export const Links = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .fields {
    display: flex;
  }

  button {
    white-space: nowrap;
    list-style: none;
    box-sizing: border-box;
    background-color: transparent;
    text-decoration: none;
    cursor: pointer;
    position: relative;
    display: block;
    padding: 10px 15px;
    line-height: 20px;
    padding-top: 15px;
    padding-bottom: 15px;
    color: #777;
    + button {
      margin-left: 10px;
    }
  }
`;
